import { CHART_COLORS } from '@gogame/components';

export const BREAK_DOWN_COLORS = CHART_COLORS.slice(0, 15);

export { CHART_COLORS };
